import type { PropsWithChildren } from 'react';
import { useTimeout } from 'react-use';

export default function DelayRender({ delay, children }: PropsWithChildren<{ delay: number }>) {
  const [isReady] = useTimeout(delay);

  return isReady() ? children : null;
}
